import { Circle as CircleOriginal, type CircleProps as CirclePropsOriginal, Square as SquareOriginal, type SquareProps as SquarePropsOriginal, Stack as StackOriginal, type StackProps as StackPropsOriginal, styled, XStack as XStackOriginal, type XStackProps as XStackPropsOriginal, YStack as YStackOriginal, type YStackProps as YStackPropsOriginal } from "tamagui";
import { hairline } from "../utils";
type ShadowVariant = "light" | "medium" | "heavy";
type VariantProps = {
  border?: boolean;
  shadow?: ShadowVariant;
};
export type YStackProps = VariantProps & YStackPropsOriginal;
export type XStackProps = VariantProps & XStackPropsOriginal;
export type StackProps = VariantProps & StackPropsOriginal;
export type CircleProps = VariantProps & CirclePropsOriginal;
export type SquareProps = VariantProps & SquarePropsOriginal;
export const variantConstants = {
  border: {
    true: {
      borderWidth: hairline,
      borderColor: "$strokeSecondary"
    }
  },
  shadow: {
    light: {
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.05,
      shadowRadius: 8,
      shadowColor: "black"
    },
    medium: {
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.08,
      shadowRadius: 12,
      shadowColor: "black"
    },
    heavy: {
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.15,
      shadowRadius: 16,
      shadowColor: "black"
    }
  }
} as const;
export const YStack = styled(YStackOriginal, {
  variants: variantConstants
});
export const XStack = styled(XStackOriginal, {
  variants: variantConstants
});
export const Stack = styled(StackOriginal, {
  variants: variantConstants
});
export const Circle = styled(CircleOriginal, {
  variants: variantConstants
});
export const Square = styled(SquareOriginal, {
  variants: variantConstants
});